import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

export const useUnsavedChangesGuard = (hasUnsavedChanges: boolean) => {
  const blocker = useBlocker(hasUnsavedChanges);

  useEffect(() => {
    if (!hasUnsavedChanges) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  return {
    isLeaveConfirmationOpen: blocker.state === 'blocked',
    confirmLeave: () => {
      if (blocker.state === 'blocked') blocker.proceed();
    },
    cancelLeave: () => {
      if (blocker.state === 'blocked') blocker.reset();
    },
  };
};
